export default __webpack_public_path__ + "navigation-examples-styled-ui-elements-1200-ac372973ee67ece7bd51ca608ea9e766.png";